import { gql } from "@apollo/client";

export const SEND_SINGLE_NMI_TRANSACTION = gql`
  mutation sendSingleNMITransaction(
    $token: String!
    $paymentdata: CustomerPayment!
  ) {
    sendSingleNMITransaction(token: $token, paymentdata: $paymentdata) {
      status
      data
      error
    }
  }
`;

export const SEND_NMI_VERIFICATION_TRANSACTIONS = gql`
  mutation sendNMIVerificationTransactions($phone: String!) {
    sendNMIVerificationTransactions(phone: $phone) {
      status
      data
      error
    }
  }
`;

export const CONIFRM_NMI_VERIFICATION_TRANSACTIONS = gql`
  mutation verifyTempNMITransactions($phone: String!, $amount1: Float!) {
    verifyTempNMITransactions(phone: $phone, amount1: $amount1) {
      status
      data
      error
    }
  }
`;
